export default __webpack_public_path__ + "static/media/logo_title.572fd7a9.png";